import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fifth-child',
  templateUrl: './fifth-child.component.html',
  styleUrls: ['./fifth-child.component.scss']
})
export class FifthChildComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
